import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, vModelText as _vModelText, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = {
  class: "list-page-panel is-header-minimal mx-6 pt-6"
};
const _hoisted_2 = {
  class: "list-page-heading"
};
const _hoisted_3 = {
  class: "list-page-heading-actions"
};
const _hoisted_4 = {
  class: "list-page-table-panel list-page-table-panel--fill mx-6"
};
const _hoisted_5 = {
  class: "data-table-shell"
};
const _hoisted_6 = {
  class: "data-table-scroll data-table-scroll--fill"
};
const _hoisted_7 = {
  class: "data-table text-sm min-w-[960px]"
};
const _hoisted_8 = {
  key: 0
};
const _hoisted_9 = {
  key: 1
};
const _hoisted_10 = {
  class: "data-table-td"
};
const _hoisted_11 = {
  class: "font-mono text-xs text-slate-900"
};
const _hoisted_12 = {
  class: "mt-1 flex items-center gap-2 text-xs text-slate-500"
};
const _hoisted_13 = ["onClick"];
const _hoisted_14 = {
  class: "data-table-td"
};
const _hoisted_15 = {
  class: "data-table-td"
};
const _hoisted_16 = {
  class: "text-xs text-slate-500"
};
const _hoisted_17 = {
  class: "data-table-td is-right money-text"
};
const _hoisted_18 = {
  class: "data-table-td"
};
const _hoisted_19 = {
  class: "data-table-td"
};
const _hoisted_20 = {
  class: "data-table-td text-xs"
};
const _hoisted_21 = {
  class: "data-table-td is-center data-table-sticky-right data-table-sticky-action"
};
const _hoisted_22 = {
  class: "flex items-center justify-center gap-1"
};
const _hoisted_23 = ["onClick"];
const _hoisted_24 = ["onClick"];
const _hoisted_25 = ["onClick"];
const _hoisted_26 = {
  key: 0,
  class: "space-y-5"
};
const _hoisted_27 = {
  class: "flex justify-end"
};
const _hoisted_28 = {
  class: "grid grid-cols-1 gap-4 rounded-lg border border-slate-200 p-4 md:grid-cols-4"
};
const _hoisted_29 = {
  class: "money-text"
};
const _hoisted_30 = {
  class: "money-text"
};
const _hoisted_31 = {
  class: "text-red-600"
};
const _hoisted_32 = {
  class: "rounded-lg border border-slate-200"
};
const _hoisted_33 = {
  class: "data-table-shell border-0 shadow-none"
};
const _hoisted_34 = {
  class: "data-table-scroll"
};
const _hoisted_35 = {
  class: "data-table text-sm"
};
const _hoisted_36 = {
  key: 0
};
const _hoisted_37 = {
  class: "data-table-td"
};
const _hoisted_38 = {
  class: "font-mono text-xs"
};
const _hoisted_39 = {
  class: "data-table-td is-right"
};
const _hoisted_40 = {
  class: "data-table-td is-right"
};
const _hoisted_41 = {
  class: "data-table-td"
};
import { onMounted, reactive, ref } from 'vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import AppPagination from '@/components/AppPagination.vue';
import ApprovalDetailModal from '@/components/ApprovalDetailModal.vue';
import ListPageShell from '@/components/ListPageShell.vue';
import PageFilterBar from '@/components/PageFilterBar.vue';
import { cancelWealthOperationApply, getWealthOperationApplyBatchDetails, getWealthOperationApplyPage } from '@/api/wealth';
import WealthAttachmentPanel from '../components/WealthAttachmentPanel.vue';
import WealthDetailDrawer from '../components/WealthDetailDrawer.vue';
import WealthOperationApplyModal from '../components/WealthOperationApplyModal.vue';
import WealthStatusBadge from '../components/WealthStatusBadge.vue';
import { applyStatusOptions, cleanPayload, formatDate, formatDateTime, formatMoney, operationTypeOptions, PAGE_SIZE_OPTIONS, pagePayload, syncPageResult } from '../utils';
export default {
  __name: 'index',
  setup(__props) {
    const filters = reactive({
      applyNo: '',
      operationType: '',
      wealthCustomerId: null,
      contractId: null,
      status: ''
    });
    const pagination = reactive({
      current: 1,
      page: 1,
      size: 10,
      total: 0,
      pages: 1
    });
    const rows = ref([]);
    const loading = ref(false);
    const applyVisible = ref(false);
    const applyType = ref('INVEST');
    const detailVisible = ref(false);
    const selectedApply = ref(null);
    const details = ref([]);
    const showApprovalDetailModal = ref(false);
    const selectedApprovalInstanceId = ref(null);
    async function loadApplies() {
      loading.value = true;
      try {
        const result = await getWealthOperationApplyPage(pagePayload(pagination, cleanPayload(filters)));
        rows.value = result?.records || [];
        syncPageResult(pagination, result);
      } finally {
        loading.value = false;
      }
    }
    function handleSearch() {
      pagination.current = 1;
      pagination.page = 1;
      loadApplies();
    }
    function handleReset() {
      Object.assign(filters, {
        applyNo: '',
        operationType: '',
        wealthCustomerId: null,
        contractId: null,
        status: ''
      });
      handleSearch();
    }
    function handlePageChange(page) {
      pagination.current = page;
      pagination.page = page;
      loadApplies();
    }
    function handleSizeChange(size) {
      pagination.size = size;
      handleSearch();
    }
    function openApply(type) {
      applyType.value = type;
      applyVisible.value = true;
    }
    async function openDetail(row) {
      selectedApply.value = row;
      detailVisible.value = true;
      details.value = await getWealthOperationApplyBatchDetails(row.id);
    }
    function openApprovalDetail(row) {
      if (!row?.approvalInstanceId) {
        ElMessage.warning('暂无审批实例');
        return;
      }
      selectedApprovalInstanceId.value = row.approvalInstanceId;
      showApprovalDetailModal.value = true;
    }
    async function cancelApply(row) {
      try {
        await ElMessageBox.confirm(`确认撤回申请 ${row.applyNo} 吗？`, '撤回申请', {
          confirmButtonText: '确认撤回',
          cancelButtonText: '取消',
          type: 'warning'
        });
        await cancelWealthOperationApply(row.id, {});
        ElMessage.success('申请已撤回');
        loadApplies();
      } catch (error) {
        if (error !== 'cancel') console.error(error);
      }
    }
    onMounted(loadApplies);
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _directive_permission = _resolveDirective("permission");
      return _openBlock(), _createBlock(ListPageShell, {
        fill: ""
      }, {
        header: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[19] || (_cache[19] = _createElementVNode("div", {
          class: "list-page-heading-main"
        }, [_createElementVNode("h1", {
          class: "list-page-title"
        }, "资金申请"), _createElementVNode("p", {
          class: "list-page-description"
        }, "提交注资、增资、减资、撤资、续期申请，并查看审批与落账状态。")], -1)), _createElementVNode("div", _hoisted_3, [_withDirectives((_openBlock(), _createElementBlock("button", {
          type: "button",
          class: "btn-primary",
          onClick: _cache[0] || (_cache[0] = $event => openApply('INVEST'))
        }, [...(_cache[14] || (_cache[14] = [_createTextVNode("提交注资", -1)]))])), [[_directive_permission, 'wealth:fund:invest']]), _withDirectives((_openBlock(), _createElementBlock("button", {
          type: "button",
          class: "btn-secondary",
          onClick: _cache[1] || (_cache[1] = $event => openApply('INCREASE'))
        }, [...(_cache[15] || (_cache[15] = [_createTextVNode("提交增资", -1)]))])), [[_directive_permission, 'wealth:fund:increase']]), _withDirectives((_openBlock(), _createElementBlock("button", {
          type: "button",
          class: "btn-secondary",
          onClick: _cache[2] || (_cache[2] = $event => openApply('DECREASE'))
        }, [...(_cache[16] || (_cache[16] = [_createTextVNode("提交减资", -1)]))])), [[_directive_permission, 'wealth:fund:decrease']]), _withDirectives((_openBlock(), _createElementBlock("button", {
          type: "button",
          class: "btn-secondary",
          onClick: _cache[3] || (_cache[3] = $event => openApply('WITHDRAW'))
        }, [...(_cache[17] || (_cache[17] = [_createTextVNode("提交撤资", -1)]))])), [[_directive_permission, 'wealth:fund:withdraw']]), _withDirectives((_openBlock(), _createElementBlock("button", {
          type: "button",
          class: "btn-secondary",
          onClick: _cache[4] || (_cache[4] = $event => openApply('ROLLOVER'))
        }, [...(_cache[18] || (_cache[18] = [_createTextVNode("提交续期", -1)]))])), [[_directive_permission, 'wealth:fund:rollover']])])])])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createVNode(PageFilterBar, {
          "shell-class": "filter-bar-shell is-embedded",
          "body-class": "filter-bar-body is-panel",
          "show-refresh": true,
          "refresh-loading": loading.value,
          onRefresh: loadApplies
        }, {
          searchActions: _withCtx(() => [_createElementVNode("button", {
            type: "button",
            class: "btn-primary",
            onClick: handleSearch
          }, "搜索"), _createElementVNode("button", {
            type: "button",
            class: "btn-secondary",
            onClick: handleReset
          }, "重置")]),
          default: _withCtx(() => [_withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => filters.applyNo = $event),
            class: "form-input form-control-sm filter-bar-field",
            placeholder: "请输入申请编号"
          }, null, 512), [[_vModelText, filters.applyNo]]), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => filters.wealthCustomerId = $event),
            type: "number",
            class: "form-input form-control-sm filter-bar-field",
            placeholder: "请输入客户ID"
          }, null, 512), [[_vModelText, filters.wealthCustomerId, void 0, {
            number: true
          }]]), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => filters.contractId = $event),
            type: "number",
            class: "form-input form-control-sm filter-bar-field",
            placeholder: "请输入合同ID"
          }, null, 512), [[_vModelText, filters.contractId, void 0, {
            number: true
          }]]), _createVNode(_component_el_select, {
            modelValue: filters.operationType,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => filters.operationType = $event),
            placeholder: "请选择类型",
            class: "form-select form-control-sm filter-bar-field"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "全部类型",
              value: ""
            }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(operationTypeOptions), item => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: item.value,
                label: item.label,
                value: item.value
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue"]), _createVNode(_component_el_select, {
            modelValue: filters.status,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => filters.status = $event),
            placeholder: "请选择状态",
            class: "form-select form-control-sm filter-bar-field"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "全部状态",
              value: ""
            }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(applyStatusOptions), item => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: item.value,
                label: item.label,
                value: item.value
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }, 8, ["refresh-loading"]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("table", _hoisted_7, [_cache[25] || (_cache[25] = _createElementVNode("thead", {
          class: "data-table-head"
        }, [_createElementVNode("tr", null, [_createElementVNode("th", {
          class: "data-table-th text-left"
        }, "申请"), _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "类型"), _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "客户/合同"), _createElementVNode("th", {
          class: "data-table-th text-right"
        }, "金额"), _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "状态"), _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "申请人"), _createElementVNode("th", {
          class: "data-table-th text-left"
        }, "申请时间"), _createElementVNode("th", {
          class: "data-table-th text-center data-table-sticky-right data-table-sticky-head data-table-sticky-action"
        }, "操作")])], -1)), _createElementVNode("tbody", null, [loading.value ? (_openBlock(), _createElementBlock("tr", _hoisted_8, [...(_cache[20] || (_cache[20] = [_createElementVNode("td", {
          colspan: "8",
          class: "data-table-empty"
        }, "加载中...", -1)]))])) : rows.value.length === 0 ? (_openBlock(), _createElementBlock("tr", _hoisted_9, [...(_cache[21] || (_cache[21] = [_createElementVNode("td", {
          colspan: "8",
          class: "data-table-empty"
        }, "暂无申请", -1)]))])) : (_openBlock(true), _createElementBlock(_Fragment, {
          key: 2
        }, _renderList(rows.value, row => {
          return _openBlock(), _createElementBlock("tr", {
            key: row.id,
            class: "data-table-row"
          }, [_createElementVNode("td", _hoisted_10, [_createElementVNode("div", _hoisted_11, _toDisplayString(row.applyNo), 1), _createElementVNode("div", _hoisted_12, [_createElementVNode("span", null, "实例 " + _toDisplayString(row.approvalInstanceId || '-'), 1), row.approvalInstanceId ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "inline-approval-link rounded px-1 text-primary-600 transition-colors hover:bg-primary-50 hover:text-primary-700",
            onClick: _withModifiers($event => openApprovalDetail(row), ["stop"])
          }, " 审批详情 ", 8, _hoisted_13)) : _createCommentVNode("", true)])]), _createElementVNode("td", _hoisted_14, [_createVNode(WealthStatusBadge, {
            type: "operation",
            value: row.operationType
          }, null, 8, ["value"])]), _createElementVNode("td", _hoisted_15, [_createElementVNode("div", null, "客户 " + _toDisplayString(row.wealthCustomerId || '-'), 1), _createElementVNode("div", _hoisted_16, "合同 " + _toDisplayString(row.contractId || '-'), 1)]), _createElementVNode("td", _hoisted_17, "¥" + _toDisplayString(_unref(formatMoney)(row.rolloverPrincipalAmount || row.amount)), 1), _createElementVNode("td", _hoisted_18, [_createVNode(WealthStatusBadge, {
            type: "apply",
            value: row.status,
            "show-dot": ""
          }, null, 8, ["value"])]), _createElementVNode("td", _hoisted_19, _toDisplayString(row.applicantName || row.applicantUserId || '-'), 1), _createElementVNode("td", _hoisted_20, _toDisplayString(_unref(formatDateTime)(row.applyTime)), 1), _createElementVNode("td", _hoisted_21, [_createElementVNode("div", _hoisted_22, [_createElementVNode("button", {
            class: "table-action-button is-primary",
            title: "详情",
            "aria-label": "详情",
            onClick: $event => openDetail(row)
          }, [...(_cache[22] || (_cache[22] = [_createElementVNode("svg", {
            class: "h-4 w-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M15 12a3 3 0 11-6 0 3 3 0 016 0z"
          }), _createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
          })], -1)]))], 8, _hoisted_23), row.approvalInstanceId ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "table-action-button is-purple",
            title: "查看审批详情",
            "aria-label": "查看审批详情",
            onClick: $event => openApprovalDetail(row)
          }, [...(_cache[23] || (_cache[23] = [_createElementVNode("svg", {
            class: "h-4 w-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"
          })], -1)]))], 8, _hoisted_24)) : _createCommentVNode("", true), row.status === 'APPROVING' ? _withDirectives((_openBlock(), _createElementBlock("button", {
            key: 1,
            class: "table-action-button is-danger",
            title: "撤回",
            "aria-label": "撤回",
            onClick: $event => cancelApply(row)
          }, [...(_cache[24] || (_cache[24] = [_createElementVNode("svg", {
            class: "h-4 w-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M6 18L18 6M6 6l12 12"
          })], -1)]))], 8, _hoisted_25)), [[_directive_permission, 'wealth:operation-apply:cancel']]) : _createCommentVNode("", true)])])]);
        }), 128))])])])]), pagination.total > 0 ? (_openBlock(), _createBlock(AppPagination, {
          key: 0,
          class: "pagination-bridge",
          pagination: pagination,
          "page-sizes": _unref(PAGE_SIZE_OPTIONS),
          onPageChange: handlePageChange,
          onSizeChange: handleSizeChange
        }, null, 8, ["pagination", "page-sizes"])) : _createCommentVNode("", true)]), _createVNode(WealthOperationApplyModal, {
          modelValue: applyVisible.value,
          "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => applyVisible.value = $event),
          "operation-type": applyType.value,
          onSubmitted: loadApplies
        }, null, 8, ["modelValue", "operation-type"]), _createVNode(WealthDetailDrawer, {
          modelValue: detailVisible.value,
          "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => detailVisible.value = $event),
          title: "资金申请详情",
          subtitle: selectedApply.value?.applyNo
        }, {
          default: _withCtx(() => [selectedApply.value ? (_openBlock(), _createElementBlock("div", _hoisted_26, [_createElementVNode("div", _hoisted_27, [selectedApply.value.approvalInstanceId ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "btn-secondary inline-flex items-center gap-1.5",
            onClick: _cache[11] || (_cache[11] = $event => openApprovalDetail(selectedApply.value))
          }, [...(_cache[26] || (_cache[26] = [_createElementVNode("svg", {
            class: "h-4 w-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"
          })], -1), _createTextVNode(" 查看审批详情 ", -1)]))])) : _createCommentVNode("", true)]), _createElementVNode("section", _hoisted_28, [_createElementVNode("div", null, [_cache[27] || (_cache[27] = _createElementVNode("div", {
            class: "text-xs text-slate-500"
          }, "操作类型", -1)), _createVNode(WealthStatusBadge, {
            type: "operation",
            value: selectedApply.value.operationType
          }, null, 8, ["value"])]), _createElementVNode("div", null, [_cache[28] || (_cache[28] = _createElementVNode("div", {
            class: "text-xs text-slate-500"
          }, "状态", -1)), _createVNode(WealthStatusBadge, {
            type: "apply",
            value: selectedApply.value.status
          }, null, 8, ["value"])]), _createElementVNode("div", null, [_cache[29] || (_cache[29] = _createElementVNode("div", {
            class: "text-xs text-slate-500"
          }, "申请金额", -1)), _createElementVNode("div", _hoisted_29, "¥" + _toDisplayString(_unref(formatMoney)(selectedApply.value.amount)), 1)]), _createElementVNode("div", null, [_cache[30] || (_cache[30] = _createElementVNode("div", {
            class: "text-xs text-slate-500"
          }, "续期本金", -1)), _createElementVNode("div", _hoisted_30, "¥" + _toDisplayString(_unref(formatMoney)(selectedApply.value.rolloverPrincipalAmount)), 1)]), _createElementVNode("div", null, [_cache[31] || (_cache[31] = _createElementVNode("div", {
            class: "text-xs text-slate-500"
          }, "客户ID", -1)), _createElementVNode("div", null, _toDisplayString(selectedApply.value.wealthCustomerId || '-'), 1)]), _createElementVNode("div", null, [_cache[32] || (_cache[32] = _createElementVNode("div", {
            class: "text-xs text-slate-500"
          }, "合同ID", -1)), _createElementVNode("div", null, _toDisplayString(selectedApply.value.contractId || '-'), 1)]), _createElementVNode("div", null, [_cache[33] || (_cache[33] = _createElementVNode("div", {
            class: "text-xs text-slate-500"
          }, "审批实例", -1)), _createElementVNode("div", null, _toDisplayString(selectedApply.value.approvalInstanceId || '-'), 1)]), _createElementVNode("div", null, [_cache[34] || (_cache[34] = _createElementVNode("div", {
            class: "text-xs text-slate-500"
          }, "失败原因", -1)), _createElementVNode("div", _hoisted_31, _toDisplayString(selectedApply.value.accountFailedReason || selectedApply.value.approvalStartFailedReason || '-'), 1)])]), _createElementVNode("section", _hoisted_32, [_cache[37] || (_cache[37] = _createElementVNode("div", {
            class: "border-b border-slate-200 px-4 py-3"
          }, [_createElementVNode("h4", {
            class: "text-sm font-semibold text-slate-900"
          }, "批次明细")], -1)), _createElementVNode("div", _hoisted_33, [_createElementVNode("div", _hoisted_34, [_createElementVNode("table", _hoisted_35, [_cache[36] || (_cache[36] = _createElementVNode("thead", {
            class: "data-table-head"
          }, [_createElementVNode("tr", null, [_createElementVNode("th", {
            class: "data-table-th text-left"
          }, "批次"), _createElementVNode("th", {
            class: "data-table-th text-right"
          }, "金额"), _createElementVNode("th", {
            class: "data-table-th text-right"
          }, "提交前本金"), _createElementVNode("th", {
            class: "data-table-th text-left"
          }, "起止日期")])], -1)), _createElementVNode("tbody", null, [details.value.length === 0 ? (_openBlock(), _createElementBlock("tr", _hoisted_36, [...(_cache[35] || (_cache[35] = [_createElementVNode("td", {
            colspan: "4",
            class: "data-table-empty"
          }, "暂无明细", -1)]))])) : (_openBlock(true), _createElementBlock(_Fragment, {
            key: 1
          }, _renderList(details.value, item => {
            return _openBlock(), _createElementBlock("tr", {
              key: item.id,
              class: "data-table-row"
            }, [_createElementVNode("td", _hoisted_37, [_createElementVNode("div", _hoisted_38, _toDisplayString(item.batchNoSnapshot || item.batchId), 1)]), _createElementVNode("td", _hoisted_39, "¥" + _toDisplayString(_unref(formatMoney)(item.amount)), 1), _createElementVNode("td", _hoisted_40, "¥" + _toDisplayString(_unref(formatMoney)(item.beforeBatchPrincipalSnapshot)), 1), _createElementVNode("td", _hoisted_41, _toDisplayString(_unref(formatDate)(item.valueDateSnapshot)) + " 至 " + _toDisplayString(_unref(formatDate)(item.maturityDateSnapshot)), 1)]);
          }), 128))])])])])]), _createVNode(WealthAttachmentPanel, {
            title: "申请附件",
            "biz-type": "OPERATION_APPLY",
            "biz-id": selectedApply.value.id,
            "can-manage": true
          }, null, 8, ["biz-id"])])) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["modelValue", "subtitle"]), _createVNode(ApprovalDetailModal, {
          modelValue: showApprovalDetailModal.value,
          "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => showApprovalDetailModal.value = $event),
          "instance-id": selectedApprovalInstanceId.value,
          type: 'wealth',
          title: "审批详情"
        }, null, 8, ["modelValue", "instance-id"])]),
        _: 1
      });
    };
  }
};